export const LESSONS_TYPE = "ComponentCoursesLessons";
export const QUIZ_TYPE = "ComponentCoursesQuizzes";
export const QUESTION_TYPE = "ComponentCoursesQuestions";
export const EMBED_TYPE = "ComponentCoursesEmbed";
export const FILE_TYPE = "ComponentCoursesFile";

export const LESSON_TYPE = {
    QUIZ: "ComponentCoursesQuizzes",
    QUESTION: "ComponentCoursesQuestions",
    EMBED: "ComponentCoursesEmbed",
    FILE: "ComponentCoursesFile",
    LESSON: "ComponentCoursesLessons",
    RESULT: "ComponentCoursesResults",
    COMPLETE: "ComponentCoursesComplete",
}